import { useState } from 'react';
import { useSelector } from 'react-redux';

import { getLastExchange } from '../../../../../Checkout/store/order/selectors';

import {
	EXCHANGE_ROUTES,
	EXCHANGE_ROUTES_MAP,
	getExchangePrevPath,
	getIsAllSelectedSegmentsWithDate,
	getSelectedPassengers,
	useExchange,
	useSkipPassengers
} from '@entities/exchange';
import { useRouter } from '@shared/lib/router';

export function useExchangeRouteControls() {
	const router = useRouter();
	const { updateOrder } = useExchange();

	const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);

	const lastExchange = useSelector(getLastExchange);
	const skipPassengers = useSkipPassengers();

	const selectedPassengers = useSelector(getSelectedPassengers);
	const isAllSelectedSegmentsWithDate = useSelector(getIsAllSelectedSegmentsWithDate);

	const currentRoute = EXCHANGE_ROUTES_MAP.get(router.currentPath);

	const prevPath = getExchangePrevPath(router.currentPath, { skipPassengers });
	const nextPath = currentRoute?.next;

	let isEnableContinue = true;
	let isShowControls = true;

	const onBackToOrder = async () => {
		if (lastExchange) {
			setIsUpdatingOrder(true);
			await updateOrder();
			setIsUpdatingOrder(false);
		}

		router.navigate('/order');
	};

	switch (router.currentPath) {
		case EXCHANGE_ROUTES.passengers:
			isEnableContinue = !!selectedPassengers.length;
			break;
		case EXCHANGE_ROUTES.segments:
			isEnableContinue = isAllSelectedSegmentsWithDate;
			break;
		case EXCHANGE_ROUTES.flights:
			isShowControls = false;
			break;
		case EXCHANGE_ROUTES.request:
			isShowControls = false;
			break;
	}

	const onBack = prevPath ? () => router.navigate(prevPath) : onBackToOrder;

	const onContinue = nextPath ? () => router.navigate(nextPath) : undefined;

	if (isShowControls && !(onBack || onContinue)) {
		isShowControls = false;
	}

	return {
		// data
		prevPath,
		nextPath,
		isEnableContinue,
		isShowControls,
		isUpdatingOrder,

		// methods
		onBack,
		onContinue,
		onBackToOrder
	};
}
